import { Authenticated, Unauthenticated } from "convex/react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useIsAdmin } from "../hooks/useIsAdmin";

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  return (
    <>
      <Unauthenticated>
        <AdminRouteUnauthenticatedRedirect />
      </Unauthenticated>
      <Authenticated>
        <AdminRouteContent>{children}</AdminRouteContent>
      </Authenticated>
    </>
  );
}

function AdminRouteUnauthenticatedRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/", { replace: true });
  }, [navigate]);

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
    </div>
  );
}

function AdminRouteContent({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { isAdmin, isLoading } = useIsAdmin();

  useEffect(() => {
    if (!isLoading && !isAdmin) {
      navigate("/", { replace: true });
    }
  }, [isAdmin, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Access Denied</h1>
        <p className="text-gray-600">You do not have permission to access this page.</p>
      </div>
    );
  }

  return <>{children}</>;
}
